import { theme } from '../../theme'
import { EventStatus } from '.'

const colors = new Map<EventStatus, string>()
colors.set(EventStatus.Full, theme.colors.palette.emerald)
colors.set(EventStatus.Advance, '#ffe200')
colors.set(EventStatus.NoPayment, theme.colors.palette.pinkishTan)
colors.set(EventStatus.Unavailable, theme.colors.palette.pinkishGrey)
colors.set(EventStatus.Canceled, '#b691c1')

const labels = new Map<EventStatus | '3-2', string>()
labels.set(EventStatus.Full, 'reservation_stage_1')
labels.set(EventStatus.Advance, 'reservation_stage_3_advance')
labels.set('3-2', 'reservation_stage_3_down_payment')
labels.set(EventStatus.NoPayment, 'reservation_stage_2')
labels.set(EventStatus.Unavailable, 'reservation_stage_4')
labels.set(EventStatus.Canceled, 'reservation_stage_5_cancelled')

const borders = new Map<
  'booking' | 'iCalendar' | 'BBEngine' | 'airbnb',
  string
>()
borders.set('booking', theme.colors.palette.booking)
borders.set('BBEngine', '#00A541')
borders.set('iCalendar', theme.colors.palette.icalendar)
borders.set('airbnb', theme.colors.palette.airbnb)

export { borders, colors, labels }
